import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const merchandisingAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: FeatureToggle.PromotedPlacements,
  permissions: Permission.PromotedPlacements,
}

// Partner-scoped hero-banners dashboard: release-variant gated (internal accounts skip
// min-version checks and preview it ahead of the r2026_11_0 rollout). Carries the same
// warehouseFeatureToggles gate as the legacy list entry so a partner sees both entries
// or neither — never a mix.
export const merchandisingHeroBannersDashboardAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: FeatureToggle.PromotedPlacements,
  permissions: Permission.PromotedPlacements,
  minICPlatformVersion: ICPlatformVersion.r2026_11_0,
}

export const merchandisingHeroBannersSingleScopeNavAccessControl: DomainAccessControlConfig = {
  ...merchandisingAccessControl,
  maxICPlatformVersionExclusive: ICPlatformVersion.r2026_11_0,
}
